export enum QuickBooksType {
  Invoice = "Invoice",
  Payment = "Payment",
  Home = "Home",
  Account = "Account",
  CreditMemo = "CreditMemo",
  Account_Retainage = "Account_Retainage",
  Home_Retainage = "Home_Retainage",
  Vendor = "Vendor",
}
